// Import: Middleware Action & Custom Types
import { CLEAN_LOCK_IMEI, CLEAN_LOCK_IMEI_ERROR } from '_models/redux/types';

// Action function
export const cleanLockImei = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_LOCK_IMEI,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: CLEAN_LOCK_IMEI_ERROR,
      payload: {},
    });
  }
};
